<template>
  <el-select v-model="cardLj" :placeholder="'共 ' + cardLjList.length+' 张优惠券，请选择'" multiple key="cardllj" @change="reduceCouponChange">
    <el-option v-for="item in cardLjList" :key="item.id+'lj'" :label="item.sname" :value="item.id+ ','+ item.sname">
      <span class="selects-spl">{{ item.sname }}</span>
      <span class="selects-spr">剩余{{ item.validPeriod }}天有效期</span>
    </el-option>
  </el-select>
</template>

<script>
const Base64 = require("js-base64").Base64;
export default {
  name: 'reduceCoupon',
  props: ['flag'],//货币基金判断
  data () {
    return {
      cardLj: [],
      cardLjList: [],
    }
  },
  mounted () {
    this.getCardLjList()
  },
  methods: {
    reduceCouponChange (arr) {
      this.$emit('reduceCouponChange', arr)
    },
    getCardLjList () {
      this.$http.post(this.$apiPath.queryCouponRecord, {
        certificateno: Base64.decode(this.$commonJs.getCookie('u_id')),
      }).then(res => {
        if (res.status !== 200 && res.data.code !== '200') return
        const result = res.data.data
        if (result && result.length > 0) {
          result.forEach(item => {
            // monetary （0只能非货基使用 1货基可用）
            if (item.idcoupons == "15005565271195634289814020399000" || item.idcoupons == "15005565881935425630120197655637" || item.idcoupons == "15005566185192142992161389954422" || item.idcoupons == "15005566185192142992161389954455") {
              item.validPeriod = this.$commonJs.DateDiff(item.enddate)
              if (this.flag) {//货币基金
                if (item.monetary == '1') {//monetary （0只能非货基使用 1货基可用）
                  this.cardLjList.push(item)
                }
              } else {
                this.cardLjList.push(item)
              }
            }
          });
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>